export default __webpack_public_path__ + "static/media/icn-wtd-braking-service.9c89b082.svg";